import { render } from "./JobAdOptionsSection.vue?vue&type=template&id=2fe2c514&scoped=true"
import script from "./JobAdOptionsSection.vue?vue&type=script&lang=js"
export * from "./JobAdOptionsSection.vue?vue&type=script&lang=js"

import "./JobAdOptionsSection.vue?vue&type=style&index=0&id=2fe2c514&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fe2c514"]])

export default __exports__